import React, { createContext, useContext, useState } from "react";
import useLocalStorage from "../custom_hooks/useLocalStorage";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

    const [user, setUser] = useLocalStorage("user", {
        isAuthenticated: false, // Default value
        role: [],
        permissions: [],
    });

    return (
        <AuthContext.Provider value={{ user, setUser }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);